/**
 * Created by Administrador on 06/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('departureCtrl', departureCtrl);

    departureCtrl.$inject = ['linkService','datePickerService','$timeout','departureService',
        'segmentFlightService','dialogService','$stateParams','airports','revenueProductionService','dateService', 'AuthServerProvider', 'userSession', 'messageService','$filter'];

    function departureCtrl(linkService,datePickerService,$timeout,departureService,segmentFlightService,
                                   dialogService,$stateParams,airports,revenueProductionService,dateService, AuthServerProvider, userSession, messageService, $filter){
        var vm = this;
        vm.displayTemplate = false;
        vm.linkService = linkService;

        vm.userSession = userSession.data;

        /* Dates */
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.dateFormat = 'dd/MM/yyyy';

        vm.beforeYesterday = dateService.addDays(new Date(), -365);
        vm.beforeYesterday.setHours(0,0,0);

        vm.originDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            }
        };

        vm.transferDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.beforeYesterday
            }
        };

        vm.dpOpenStatus = {
            'originDate': false,
            'transferDate': false
        };

        loadChannels();
        loadTemplate();

        vm.openCalendar = function(date) {
            vm.dpOpenStatus[date] = true;
        };

        vm.eventChangeTemplate = function() {
            vm.departure.observation = '';
            if(vm.departure.template != undefined) {
                vm.departure.observation = vm.departure.template.content
                    .replace('${cityOrigin}', vm.departure.originAirport.iata)
                    .replace('${cityDestination}', vm.departure.destinyAirport.iata)
                    .replace('${flightNumber}', vm.departure.originStretch.flightNumber)
                    .replace('${dateHour}', $filter('date')(vm.departure.originStretch.departureDatetime, "dd/MM/yyyy HH:mm"))
                    .replace('${dateTravel}', $filter('date')(vm.departure.originStretch.departureDatetime, "dd/MM/yyyy"))
                    .replace('${newHour}', $filter('date')(vm.departure.originStretch.departureDatetime, "HH:mm"));
            }
        }

        vm.formDepartureValid =  function(isValid) {
            if (isValid) {
                var phones = '';
                for(var i = 0; i < vm.originPnrs.length; i++) {
                    phones += vm.removeSpacesCharacters(vm.originPnrs[i]._embedded.passengerPnrs[0].phone)+',';
                }
                if(phones.length>2) {
                    phones = phones.substring(0, phones.length-1)
                }

                var t1 = vm.departure.template.content.replace("\n"," ");
                vm.variables = vm.extractVariables(t1);
                var dataTemplate = "";
                for(var k=0; k<vm.variables.length;k++) {
                    if(vm.variables[k] == 'cityOrigin') dataTemplate += "\""+vm.variables[k] +"\":\""+ vm.departure.originAirport.iata +"\",";
                    if(vm.variables[k] == 'cityDestination') dataTemplate += "\""+vm.variables[k] +"\":\""+ vm.departure.destinyAirport.iata +"\",";
                    if(vm.variables[k] == 'flightNumber') dataTemplate += "\""+vm.variables[k] +"\":\""+ vm.departure.originStretch.flightNumber +"\",";
                    if(vm.variables[k] == 'dateHour') dataTemplate += "\""+vm.variables[k] +"\":\""+ $filter('date')(vm.departure.originStretch.departureDatetime, "dd/MM/yyyy HH:mm") +"\",";
                    if(vm.variables[k] == 'dateTravel') dataTemplate += "\""+vm.variables[k] +"\":\""+ $filter('date')(vm.departure.originStretch.departureDatetime, "dd/MM/yyyy") +"\",";
                    if(vm.variables[k] == 'newHour') dataTemplate += "\""+vm.variables[k] +"\":\""+ $filter('date')(vm.departure.originStretch.departureDatetime, "HH:mm") +"\",";
                }
                var save = {
                    "code": vm.departure.template.id,
                    "dataTemplate": '{' + dataTemplate.substring(0,dataTemplate.length-1)+ '}',
                    "search": phones
                }
                if(phones.length > 0) {
                    departureService.sendDataReportPostConfig("CONFIG", save).then(function (response) {
                        messageService.successMsg('air.departure.successMsg');
                        linkService.reloadRoute('departures', null);
                    });
                } else {
                    messageService.warning('air.departure.warningMsg','');
                }
            }
        }

        vm.removeSpacesCharacters = function(text) {
            // eslint-disable-next-line angular/definedundefined
            if (text !== null && text !== undefined) {
                text = text.replace(/[\s\-()]/g, '');
                text = text === '' ? null : text;
            }

            return text;
        };

        vm.cancelDeparture = function(){
            linkService.reloadRoute('departures', null);
        }

        vm.extractVariables = function(text) {
            var matches = text.match(/\$\{([^}]+)\}/g);

            if (!matches) {
                return [];
            }

            return matches.map(function(value) {
                return value.slice(2, -1);
            });
        };

        /* End dates */
        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.airports = airports;

        vm.departure = {
            originDate: new Date(),
            transferDate: new Date(),
            originAvailableSeats: 0,
            transferAvailableSeats: 0,
            originSegmentFlight: {},
            transferSegmentFlight: {}
        };

        function loadChannels() {
            departureService.findChannel(vm.userSession.login).then(function (response) {
                vm.channels = [];
                if(response.data.length > 0) {
                    vm.channels = response.data;
                } else {
                    messageService.registerDeleteGeneralError('departure','air.promotion.thereIsNoInformation');
                }
            });
        }

        function loadTemplate() {
            departureService.findTemplate('PUSH', 'TAMep', vm.userSession.login).then(function (response) {
                vm.templates = [];
                if(response.data.length > 0) {
                    vm.templates = response.data;
                } else {
                    messageService.registerDeleteGeneralError('departures','air.departure.thereIsNoInformation');
                }
            });
        }
        vm.eventChangeOriginDestiny = function(dateType){
            var origin = (dateType == 'originDate')?vm.departure.originAirport : vm.departure.originTransfer;
            var destiny = (dateType == 'originDate')?vm.departure.destinyAirport : vm.departure.destinyTransfer;
            var date = (dateType == 'originDate')?vm.departure.originDate : vm.departure.transferDate;
            if(origin == undefined || destiny == undefined){
                if(dateType=='originDate'){
                    vm.originStretches = [];
                    vm.originPnrs = [];
                }else{
                    vm.transferStretches = [];
                    vm.transferPnrs = [];
                }
            }else{
                vm.hidden();
                $timeout(function(){
                    if (origin.iata == destiny.iata) {
                        dialogService.dialogError('air.departure.originAndDestinyMustBeDifferent');
                        if(dateType=='originDate'){
                            vm.departure.destinyAirport = undefined;
                        }else{
                            vm.departure.destinyTransfer = undefined;
                        }
                    }else{

                    }
                    segmentFlightService.getSegmentByOriginDestinyDate(vm.linkService.getLinkId(origin._links.self.href),vm.linkService.getLinkId(destiny._links.self.href),date.getTime())
                        .then(function (response) {
                            if(dateType == 'originDate'){
                                vm.originStretches = response;
                            }else if(dateType == 'transferDate'){
                                vm.transferStretches = response;
                            }
                        });

                }, 100);
            }
        }

        vm.hidden = function() {
            vm.departure.template = null;
            vm.departure.observation = '';
        }
        vm.eventChangeStretch = function(dateType){
            vm.displayTemplate = false;
            vm.hidden();
            var stretch = (dateType == 'originDate') ? vm.departure.originStretch : vm.departure.transferStretch;
            if(stretch == undefined){
                if(dateType=='originDate'){
                    vm.originPnrs = [];
                }else{
                    vm.transferPnrs = [];
                }
            }else {
                if ((vm.departure.originStretch != undefined && vm.departure.transferStretch != undefined)
                     && (vm.departure.originStretch.segmentFlightId == vm.departure.transferStretch.segmentFlightId)) {
                    dialogService.dialogError('air.departure.notTransferToTheSameFlight');
                    vm.departure.transferStretch = undefined;
                    vm.transferPnrs = [];
                } else {
                    $timeout(function () {
                        if (dateType == 'originDate') {
                            vm.originPnrs = [];
                            revenueProductionService.getOverSoldAll(stretch.segmentFlightId).then(function (response) {
                                    vm.departure.originAvailableSeats = ((response.data.takeOffCapacity+response.data.overLoad)-response.data.occupied);
                                    vm.departure.originSegmentFlight = response.data;
                                    vm.displayTemplate = true;
                                });

                        } else if (dateType == 'transferDate') {
                            vm.transferPnrs = [];
                            revenueProductionService.getOverSoldAll(stretch.segmentFlightId)
                                .then(function (response) {
                                    vm.departure.transferAvailableSeats =
                                        ((response.data.takeOffCapacity+response.data.overLoad)-response.data.occupied);
                                    vm.departure.transferSegmentFlight = response.data;
                                });
                        }

                        departureService.getPNRs(stretch.segmentFlightId, $stateParams.page, $stateParams.size)
                            .then(function (response) {
                                if (dateType == 'originDate') {
                                    angular.forEach(response, function (pnr) {
                                        vm.originPnrs.push(pnr);
                                    });
                                    //vm.originPnrs = response;
                                } else if (dateType == 'transferDate') {
                                    //vm.transferPnrs = response;
                                    angular.forEach(response, function (pnr) {
                                        vm.transferPnrs.push(pnr);
                                    });
                                }
                            });

                        departureService.getCheckInPNRs(stretch.segmentFlightId, $stateParams.page, $stateParams.size)
                            .then(function (response) {
                                if (dateType == 'originDate') {
                                    angular.forEach(response, function (pnr) {
                                        pnr.status = 'CHECKED';
                                        vm.originPnrs.push(pnr);
                                    });
                                } else if (dateType == 'transferDate') {
                                    angular.forEach(response, function (pnr) {
                                        pnr.status = 'CHECKED';
                                        vm.transferPnrs.push(pnr);
                                    });
                                }
                            });
                    }, 100);
                }
            }
        }
    }
})();
